<script lang="ts">
	import type { SbImage } from '../types';
	import PageGrid from '../components/pageGrid.svelte';
	import Image from '../components/image.svelte';
	import type { ISbStoryData } from '@storyblok/js';
	import { editable } from '../editable';
	import Blok from '../blok.svelte';

	interface Props {
		content: ISbStoryData<{
			image?: SbImage;
			badge: string;
			eyebrow: string;
			price: string;
			interval: string;
			subline: string;
			pricing_cards: ISbStoryData['content'][];
			button: ISbStoryData['content'][] | undefined;
		}>['content'];
	}

	let { content }: Props = $props();
</script>

<section use:editable={content}>
	<PageGrid>
		<div
			class="group relative col-span-full overflow-hidden rounded-[20px] lg:col-start-3 lg:col-end-11"
		>
			{#if content.image?.filename}
				<Image
					class="aspect-square h-full w-full transform-gpu object-cover transition-transform duration-600 group-hover:scale-105 lg:aspect-video"
					src={content.image.filename}
					alt={content.image.alt ?? ''}
					title={content.image.title ?? ''}
				/>
			{/if}
			<div class="image-overlay absolute inset-0"></div>
			<div class="absolute inset-4 flex flex-col justify-between text-stone-5 lg:inset-10">
				<div class="flex text-[20px]/[110%] font-semibold">
					{#if content.badge}
						<p class="rounded-xl bg-stone-5 p-3 text-brown-2">{content.badge}</p>
					{/if}
				</div>
				<div>
					<p class="text-[20px]/[140%] lg:text-[24px]">{content.eyebrow}</p>
					<p class="mt-1 text-green-5 lg:mt-2">
						<span class="text-[56px]/[110%] font-semibold lg:text-[64px]">{content.price}</span
						><span class="text-[20px]/[140%] lg:text-[24px]">{content.interval}</span>
					</p>
					<p class="text-[16px]/[140%] lg:mt-1 lg:text-[20px]">{content.subline}</p>
				</div>
			</div>
		</div>
		<div class="col-span-full mt-4 lg:col-start-3 lg:col-end-11 lg:mt-5">
			<div class="flex flex-col gap-x-[18px] gap-y-4 lg:flex-row">
				{#each content.pricing_cards || [] as card}
					<div class="flex-1">
						<Blok content={card} />
					</div>
				{/each}
			</div>
			<div class="mt-10 flex justify-center lg:mt-15">
				{#if content.button?.length}
					<Blok content={content.button[0]} />
				{/if}
			</div>
		</div>
	</PageGrid>
</section>

<style>
	.image-overlay {
		background: linear-gradient(30deg, rgba(36, 13, 2, 0.56) 0.52%, rgba(36, 13, 2, 0.08) 103.11%);

		@media (min-width: 1024px) {
			background: linear-gradient(90deg, rgba(36, 13, 2, 0.48) 0%, rgba(36, 13, 2, 0) 100%);
		}
	}
</style>
